import { AIChatBlockSchema } from '@hive/core/blocksuite/ai/blocks/ai-chat-block/model';
import { HiveSchemas } from '@blocksuite/hive/schemas';
import { Schema } from '@blocksuite/hive/store';

let _schema: Schema | null = null;
export function getHiveWorkspaceSchema() {
  if (!_schema) {
    _schema = new Schema();

    _schema.register([...HiveSchemas, AIChatBlockSchema]);
  }

  return _schema;
}
